import { call, put } from 'redux-saga/effects';
import {
    requestServiceAccounts,
    requestCreateServiceAccount,
    requestRotateServiceAccount,
    requestActivateServiceAccount,
    requestDeactivateServiceAccount,
    requestDeleteServiceAccount,
} from '../requests/serviceAccount';
import { showAlert } from '../../slices/alerts';

function* runRequest(requestFn, callback, args = []) {
    try {
        const response = yield call(requestFn, ...args);
        if (callback) callback(response.data);
    } catch (error) {
        const msg = error?.response?.data?.msg || error.message;
        yield put(showAlert({ severity: 'error', message: msg }));
        if (callback) callback(null);
    }
}

export function* handleGetServiceAccounts(action) {
    yield call(runRequest, requestServiceAccounts, action.payload.callback);
}

export function* handleCreateServiceAccount(action) {
    yield call(runRequest, requestCreateServiceAccount, action.payload.callback, [action.payload.data]);
}

export function* handleRotateServiceAccount(action) {
    yield call(runRequest, requestRotateServiceAccount, action.payload.callback, [action.payload.id]);
}

export function* handleActivateServiceAccount(action) {
    yield call(runRequest, requestActivateServiceAccount, action.payload.callback, [action.payload.id]);
}

export function* handleDeactivateServiceAccount(action) {
    yield call(runRequest, requestDeactivateServiceAccount, action.payload.callback, [action.payload.id]);
}

export function* handleDeleteServiceAccount(action) {
    yield call(runRequest, requestDeleteServiceAccount, action.payload.callback, [action.payload.id]);
}
